import oidcActions from './actions';

export const initialState = {
	user: undefined,
	isLoadingUser: true,
};

export const oidcReducer = (state = initialState, action) => {
	switch (action.type) {
		case oidcActions.SET_USER:
			return { ...state, user: action.payload };
		case oidcActions.SET_LOADING:
			return { ...state, isLoadingUser: action.payload };
		default:
			return state;
	}
};

export default oidcReducer;
